<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"  >
  <p style="font-size: 20px; color: white">{{'messages.loadingList' | translate}}</p>
</ngx-spinner>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active">{{'pages.catalogManagement' | translate}}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
      <div class="row">
        <div class="col-2" style="margin-bottom: 20px">
          <a href="/dashboard/administrator/catalogue-management/create">
            <button type="button" class="btn btn-primary waves-effect waves-light">
              <i class="bx bx-plus font-size-16 align-middle mr-2"></i> {{'common.add' | translate}}
            </button></a>
        </div>
        <div class="col-4" style="margin-bottom: 20px">
          <button type="button" class="btn btn-primary waves-effect waves-light" (click)="synchronisation_session()">
            <i class="font-size-12 align-middle mr-2"></i> {{'common.syncSessions' | translate}}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12" style="margin-bottom: 20px;">
          <input class="form-control" type="text" [attr.placeholder]="'catalog.searchCatalog' | translate" [(ngModel)]="vQuery">
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-12">
          <div id="accordion">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">{{'pages.listCatalogs' | translate}} ({{catalogues.length}})</h4>
                <div class="card-catalogue mb-3" *ngFor="let catalogue of catalogues | orderBy: order:reverse: false | filter:vQuery | paginate: { itemsPerPage: 10, currentPage: page } | slice:0:show; let i=index">
                  <div class="card-body border">
                    <div class="row mb-2">
                      <div class="col-sm-9">
                        <h5 class="card-titre">{{catalogue.titre}}</h5>
                        <div class="mt-3">{{'fields.description' | translate}} :</div>
                        <div class="mt-2">{{ catalogue.description }}</div>
                        <div class="mt-3">{{'fields.language' | translate}} : {{ catalogue.langue }}</div>
                      </div>
                      <div class="col-sm-3">
                        <i class="bx bx-edit pointer" (click)="update(catalogue.id)">{{'common.edit' | translate}} </i>
                        <i class="bx bx-trash-alt pointer" (click)="delete(catalogue.id)">{{'common.delete' | translate}}</i>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4" style="margin-bottom: 20px">
                        <a href="/dashboard/administrator/catalogue-chapitre/{{catalogue.id}}/create">
                          <button type="button" class="btn btn-primary waves-effect waves-light">
                            <i class="bx bx-plus font-size-12 align-middle mr-2"></i> {{'common.addChapter' | translate}}
                          </button></a>
                      </div>
                    </div>
                    <mat-accordion>
                      <mat-expansion-panel *ngFor="let chapitre of catalogue.chapitres" [expanded]="chapitre.showDescription">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div class="title mb-0 mt-0">
                              {{ chapitre.titre }}
                            </div>
                          </mat-panel-title>
                          <div class="mr-5">
                          <i class="bx bx-edit pointer" (click)="update_chapitre(catalogue.id,chapitre.id)">{{'common.edit' | translate}} </i>
                          <i class="bx bx-trash-alt pointer" (click)="delete_chapitre(chapitre.id)">{{'common.delete' | translate}}</i>
                          </div>
                        </mat-expansion-panel-header>
                        <div>{{'fields.description' | translate}} :</div>
                        <div>{{ chapitre.description }}</div>
                        <div class="table-responsive mt-3 mb-3">
                          <table class="table mb-0">
                            <thead>
                            <tr>
                              <th>{{'fields.title' | translate}}</th>
                              <th>{{'fields.duration' | translate}}</th>
                              <th>{{'fields.type' | translate}}</th>
                              <th>{{'fields.certificateCode' | translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let session of chapitre.sessions_chapitres">
                              <td>{{session.title_catalogue}}</td>
                              <td>{{session.duree}}</td>
                              <td>{{session.type}}</td>
                              <td>{{session.code_cert}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
                <div class="col-md-12 text-center">
                  <pagination-controls
                    previousLabel="Précedent"
                    nextLabel="Suivant"
                    responsive="true"
                    (pageChange)="page = $event"></pagination-controls>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
        <!-- end row -->
      </div>
      <!-- container-fluid -->
    </div>
    <!-- End Page-content -->
    <app-footer></app-footer>
  </div>
</div>

